import * as React from "react";
import _ from "lodash";
import { decodeToken } from "react-jwt";
import { Fragment } from "react";
import {
  IFilterData,
  BaseListComponentState,
} from "../../../components/BaseListComponent";
import {
  createFilterData,
  mapEntityList,
} from "../../../services/utility/autoMapperService";
import BaseListComponent from "../../../components/BaseListComponent";
import ItemsTable, {
  filterFieldData,
} from "../../../components/tableComponents/itemsTable";
import TableFilterPane from "../../../components/tableComponents/tableFilterPane";
import RejectedLoanRequestDetails from "./rejectedLoanRequestDetails";
import loanRequestService from "../../../services/hybridAppraisal/loanRequestService";
import financialGroupService from "../../../services/hybridAppraisal/financialGroupService";
import rolesService from "../../../services/auth/rolesService";
import appraisalInstitutionService from "../../../services/hybridAppraisal/appraisalInstitutionService";
import appraisalPlanService from "../../../services/hybridAppraisal/appraisalPlanService";
import { getCurrentUserSession } from "../../../services/auth/authService";
import regionsService from "../../../services/auth/regionsService";

export interface RejectedLoanRequestsProps { }

export interface RejectedLoanRequestsState extends BaseListComponentState {
  data: IFilterData;
  currentPage: number;
  pageSize: number;
  tableItems: any;
  totalSize: number;
  fetchingDetail: boolean;
  filterValueInput: filterFieldData;
  item: any;
  userRoles: any;
  systemProcess: any;
  accessibleBranches: any;
}

class RejectedLoanRequestsList extends BaseListComponent<RejectedLoanRequestsState> { }

class RejectedLoanRequests extends React.Component<
  RejectedLoanRequestsProps,
  RejectedLoanRequestsState
> {
  _isMounted = false;
  constructor(props: RejectedLoanRequestsProps) {
    super(props);
    this.state = {
      data: createFilterData(["customerName", "loanType"]) as IFilterData,
      currentPage: 1,
      pageSize: Number(process.env.REACT_APP_DEFAULT_PAGESIZE) || 10,
      fetching: false,
      fetchingDetail: false,
      tableItems: [],
      totalSize: 0,
      filterValueInput: [
        { name: "customerName", fieldType: "text", value: "" },
        {
          name: "loanType",
          fieldType: "select",
          options: ["Individual", "Corporate"],
          value: "",
        }
      ],
      item: {},
      showDetailsModal: false,
      showEditModal: false,
      showTableFilterModal: false,
      showTrailModal: false,
      userRoles: [],
      systemProcess: [],
      accessibleBranches: []
    };
  }

  handlePageChange = async (currentPage: number, pageSize: number, data?: IFilterData) => {
    currentPage = currentPage < 0 ? this.state.currentPage : currentPage;
    pageSize = pageSize < 0 ? this.state.pageSize : pageSize;
    this.setState({ fetching: true });
    let dataClone =
      typeof data === "undefined" ? { ...this.state.data } : { ...data };

    const decodedToken = decodeToken(getCurrentUserSession().token || "");
    dataClone["InstitutionCode"] = { item1: "=", item2: decodedToken?.["InstitutionCode"] }

    try {
      const loanRequests = await loanRequestService.filterRejectedLoanRequests(
        {filters: dataClone, accessibleBranchCodes: this.state.accessibleBranches},
        pageSize,
        currentPage
      );
      this.setState({
        tableItems: mapEntityList({
          entityList: loanRequests.data.item2,
          properties: [
            { oldName: "customerName", newName: "Name" },
            { oldName: "phonenumber", newName: "phoneNumber" },
            { oldName: "gender", newName: "gender" },
            {
              isTag: true,
              oldName: "maritalStatus",
              newName: "maritalStatus",
              success: "Active",
              danger: "Inactive",
              default: "Married",
              primary: "Single",
              secondary: "Divorced",
              warning: "Other",
              light: "Widowed",
              dark: "dark",
            },
            {
              isTag: true,
              oldName: "loanType",
              newName: "loanType",
              success: "Individual",
              danger: "Inactive",
              default: "default",
              primary: "Corporate",
              secondary: "secondary",
              warning: "warning",
              light: "light",
              dark: "dark",
            },
            { oldName: "loanAmount", newName: "loanAmount" },
            { oldName: "dateCreated", newName: "dateCreated" },
            {
              isTag: true,
              oldName: "requestStatus",
              newName: "status",
              success: "Active",
              danger: "Rejected",
              default: "default",
              primary: "primary",
              secondary: "secondary",
              warning: "Created",
              light: "light",
              dark: "dark",
            },
          ],
        }),
        currentPage,
        totalSize: loanRequests.data.item1,
        fetching: false,
      });
    } catch (ex) {
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status <= 499
      ) {
        this.setState({ fetching: false });
      } else {
        this.setState({ fetching: false });
      }
    }
  };

  handleOnExport = async (type: string) => { };

  fetchItemById = async (item: any) => {
    this.setState({ fetchingDetail: true });
    const loanRequest = await loanRequestService.retrieveById(item.id);
    const loanRequestDetail = loanRequest.data;
    const financialGroup = await financialGroupService.retrieveFinancialGroupByProductCode(loanRequestDetail.productCode, (item.loanAmount / 100), loanRequestDetail.institutionCode);
    loanRequestDetail["financialGroup"] = financialGroup.data;
    if (this._isMounted) {
      this.setState({ item: loanRequestDetail, fetchingDetail: false });
    }
  };

  getFilteredItems = (data: IFilterData): IFilterData => {
    let filteredItems: IFilterData = {};
    Object.keys(data).forEach((key) => {
      if (data[key].item2 !== "") {
        filteredItems[key] = data[key];
      }
    });
    return filteredItems;
  };

  async componentDidMount() {
    this._isMounted = true;
    this.handlePageChange(this.state.currentPage, this.state.pageSize);
    const decodedToken = decodeToken(getCurrentUserSession().token || "");
    const response = await Promise.allSettled([
      rolesService.retrieveAllRoles(),
      appraisalInstitutionService.retrieveByInstitutionCode(decodedToken?.["InstitutionCode"]),
      regionsService.getAccessibleBranchCodes()
    ])
    const userRoles = response[0].status == "fulfilled" ? response[0].value.data : [];
    const appraisalInstitution = response[1].status == "fulfilled" ? response[1].value.data : [];
    const accessibleCodes = response[2].status == "fulfilled" ? response[2].value.data : [];

    const appraisalPlan = await appraisalPlanService.retrieveById(appraisalInstitution.planId);
    const reports = appraisalPlan.data.reports
    const validations = appraisalPlan.data.validations
    const systemProcess = [...reports, ...validations];
    if (this._isMounted) {
      this.setState({
        userRoles: userRoles,
        systemProcess: systemProcess,
        accessibleBranches: accessibleCodes
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const {
      currentPage,
      pageSize,
      tableItems,
      totalSize,
      fetching,
      item,
      fetchingDetail,
      userRoles,
      systemProcess
    } = this.state;
    return (
      <Fragment>
        <div className="container-fluid relative animatedParent animateOnce">
          <div className="animated fadeInUpShort go">
            <div className="row my-3 mx-2">
              <h3>
                <b>Rejected Loan Requests</b>
              </h3>
            </div>
            <RejectedLoanRequestsList
              pageChangeHandler={this.handlePageChange}
              fetchingDetail={fetchingDetail}
              initialValues={{
                data: this.state.data,
                fetching: false,
                showDetailsModal: false,
                showEditModal: false,
                showTableFilterModal: false,
                showTrailModal: false,
                tableItems: [],
                filterValueInput: this.state.filterValueInput,
                item: {},
              }}
              tableItems={tableItems}
              item={item}
              DetailsModal={({
                item,
                onToggleDetailsModal,
                onToggleEditModal,
                showDetailsModal,
              }) => (
                <Fragment>
                  <RejectedLoanRequestDetails
                    showDetailsModal={showDetailsModal}
                    toggleDetailsModal={onToggleDetailsModal}
                    toggleEditModal={onToggleEditModal}
                    item={item}
                    userRoles={userRoles}
                    systemProcess={systemProcess}
                  />
                </Fragment>
              )}
              ListPayLoad={({
                data,
                showTableFilterModal,
                tableItems,
                onToggleDetailsModal,
                onToggleTableFilterModal,
                onHandleFilterItemRemove,
                filterValueInput,
              }) => (
                <div className="row">
                  <div className="col-md-12">
                    <div className="card no-b">
                      <div className="card-body">
                        <div className="card-title">
                          <div id="list-filters" className="ml-4 mr-4">
                            <TableFilterPane
                              filteredItems={this.getFilteredItems(data)}
                              handleFilterRemove={onHandleFilterItemRemove}
                            />
                          </div>
                          <div id="list-table">
                            <ItemsTable
                              data={data}
                              items={tableItems}
                              filterValueInput={filterValueInput}
                              showTableFiltermodal={showTableFilterModal}
                              toggleTableFiltermodal={onToggleTableFilterModal}
                              name="Rejected Loan Requests"
                              currentPage={currentPage}
                              pageSize={pageSize}
                              totalSize={totalSize}
                              fetching={fetching}
                              handlePageChange={this.handlePageChange}
                              onViewDetails={(item: any) => {
                                this.fetchItemById(item);
                                onToggleDetailsModal();
                              }}
                              handleOnExport={this.handleOnExport}
                              timeColumn={["dateCreated"]}
                              amountColumn={["loanAmount"]}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            ></RejectedLoanRequestsList>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default RejectedLoanRequests;
